import React from "react"

import ClickableImage from "@components/clickableImage"
import styles from "./tasks.module.scss"

const Tasks = ({ tasks }) => {
  return (
    <div className={styles.tasks}>
      {tasks.map(task => (
        <div key={task.title}>
          {task.image ? (
            <ClickableImage
              src={task.image}
              alt={task.title}
              className={styles.image}
            />
          ) : (
            <div className={styles.image}>
              {task.coming}
              <br />
              COMING SOON
            </div>
          )}
          <p>{task.title}</p>
        </div>
      ))}
    </div>
  )
}

export default Tasks
